export { ChallengeParticipantSwitcher } from './ChallengeParticipantSwitcher';
export type { ChallengeParticipantSwitcherProps } from './ChallengeParticipantSwitcher';
